// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { getIabCategoryListFailed, getIabCategoryListRequested, getIabCategoryListSucceeded } from './select-iab-category.actions';
import { IabCategoryListResponse } from '@par/app/core/model/dictionaries.response';

export const STATE_NAME_SELECT_IAB_CATEGORY = 'select-iab-category';

export interface State {
  response?: IabCategoryListResponse;
  responseError: boolean;
  responseLoading: boolean;
}

const initialState: State = {
  response: undefined,
  responseError: false,
  responseLoading: false,
};

const reducer = createReducer(
  initialState,
  on(getIabCategoryListRequested, (state) => ({
    ...state,
    response: undefined,
    responseLoading: true,
    responseError: false,
  })),
  on(getIabCategoryListSucceeded, (state, {response}) => ({
    ...state,
    responseLoading: false,
    response,
    responseError: false,
  })),
  on(getIabCategoryListFailed, (state) => ({...state, responseLoading: false, responseError: true})),
);

export function selectIabCategoryReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}
